import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../components/common-modal/CommonModal';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';

import scss from './ChangeAssistantModal.module.scss';

function ChangeAssistantModal({ isOpen, onCancel, onChangeAndReset }) {
  const { t } = useTranslation('scout');

  return (
    <CommonModal isOpen={isOpen} onClose={onCancel} wrapperClassName={scss.wrapper}>
      <h3 className={scss.title}>{t('changeTheAssistant')}?</h3>

      <span className={scss.subTitle}>{t('changeTheAssistantDescription')}</span>

      <div className={scss.actions}>
        <CommonButton type='button' styleColor={BUTTON_STYLES.SECONDARY} maxWidth={90} onClick={onCancel}>
          {t('cancel')}
        </CommonButton>

        <CommonButton type='button' styleColor={BUTTON_STYLES.PRIMARY} maxWidth={160} onClick={onChangeAndReset}>
          {t('submitAndReset')}
        </CommonButton>
      </div>
    </CommonModal>
  );
}

export default ChangeAssistantModal;
